var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseReportItemComponent } from "./base-report-item-component";
var ScaleDataSectionComponent = /** @class */ (function (_super) {
    __extends(ScaleDataSectionComponent, _super);
    function ScaleDataSectionComponent() {
        var _this = _super.call(this) || this;
        _this._scaleResults = [];
        return _this;
    }
    ScaleDataSectionComponent.prototype.setReportData = function (data, results, variables) {
        var _this = this;
        if (!data || !results) {
            return;
        }
        if (data.assessment) {
            this._assessmentResult = results.find(function (r) { return r.assessment.uid == data.assessment; });
        }
        else if (data.computed_result) {
            this._assessmentResult = results.find(function (r) { return r.id === data.computed_result; });
        }
        if (this._assessmentResult) {
            // normally we take all the scales... but we can filter them here
            if (data.scales && data.scales.length) {
                this._scaleResults = this._assessmentResult.scaleResults
                    .filter(function (sr) { return data.scales.indexOf(sr.scale.id) >= 0; });
            }
            else {
                this._scaleResults = this._assessmentResult.scaleResults;
            }
            this._assessmentResult.scaleResults.forEach(function (s) { return console.log(_this._assessmentResult.assessment.name, "=>", s.scale.name, "(", s.scale.id, ")"); });
        }
    };
    ScaleDataSectionComponent.prototype.ngOnInit = function () {
    };
    ScaleDataSectionComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    Object.defineProperty(ScaleDataSectionComponent.prototype, "ScaleResults", {
        get: function () {
            return this._scaleResults;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleDataSectionComponent.prototype, "AssessmentResult", {
        get: function () {
            return this._assessmentResult;
        },
        set: function (v) {
            this._assessmentResult = v;
        },
        enumerable: true,
        configurable: true
    });
    return ScaleDataSectionComponent;
}(BaseReportItemComponent));
export { ScaleDataSectionComponent };



// WEBPACK FOOTER //
// ./src/app/reports/models/scale-list-data-component.ts.pre-build-optimizer.js